export default __webpack_public_path__ + "static/media/gallery4.98925b7b.jpg";